import { Component } from '../lib/ComponentBase';
import { simpleComponent } from '../lib/ComponentHelpers';
import type { DataComponent } from '../types/Components';

/**
 * A component that stores rendering information for an entity.
 */
class Renderable extends Component implements DataComponent {
  spriteKey: string;
  scale: number;

  constructor(data: { spriteKey?: string; scale?: number } = {}) {
    super();
    this.spriteKey = data.spriteKey ?? '';
    this.scale = data.scale ?? 1.0;
  }
}

export default simpleComponent(Renderable);
